import { InfoButton } from '@/domain/mitarbeiter/features/anlageassistent/components/InfoButton';
import { ArbeitstageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/ArbeitstageSelect';
import { StundenbewertungBlock } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbewertungBlock';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Body, Heading, Separator } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenAllgemein() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col md:gap-10 gap-6">
      <div className="flex flex-col gap-4">
        <Heading className=" flex items-center gap-1">
          {ctx.getCurrentSubStep()?.title}
          <InfoButton>
            <Body>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.info',
              )}
            </Body>
          </InfoButton>
        </Heading>
        <div className="grid md:grid-cols-2">
          <form.AppField name="abwesenheiten.allgemein.anzahlUrlaubstage">
            {(field) => (
              <field.TextInput
                suffix={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.suffix',
                )}
                inputMode="numeric"
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.label',
                )}
                isRequired
              />
            )}
          </form.AppField>
        </div>
      </div>
      <Separator />
      <div className="flex flex-col gap-4">
        <Heading>
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.title',
          )}
        </Heading>
        <form.Subscribe
          selector={(state) => state.values.abwesenheiten.allgemein.dynamisch}>
          {(dynamisch) => (
            <ArbeitstageSelect
              disableOptionFlexibel={
                dynamisch === 'wochenschnitt' ||
                dynamisch === 'drei_monatsschnitt'
              }
            />
          )}
        </form.Subscribe>
      </div>
      <Separator />
      <StundenbewertungBlock />
    </div>
  );
}
